import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../css/ClassPaymentStatus.css";

class ClassPaymentFailed extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleBackToClasses = () => {
    // Send user back to the 4 services classes page as requested
    this.props.history.push("/classes");
  };

  render() {
    const state = (this.props.location && this.props.location.state) || {};
    const errorMsg =
      state.error ||
      state.message ||
      "The payment could not be processed by your bank or the transaction was cancelled.";
    const orderId = state.orderId || state.order_id || null;

    return (
      <div className="cps-page-wrapper">
        <div className="cps-container">
          <div className="cps-card">
            {/* Failed Animated Icon */}
            <div className="cps-icon-wrap cps-icon-failed">
              <svg
                width="42"
                height="42"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>

            <span className="cps-badge cps-badge-failed">Transaction Failed</span>
            <h1 className="cps-title">Payment Not Completed</h1>
            <p className="cps-subtitle">
              We couldn't activate your membership because the payment was not completed or was cancelled.
            </p>

            {/* Details Box */}
            <div className="cps-details-box">
              <div className="cps-detail-row">
                <span className="cps-detail-label">Status</span>
                <span className="cps-detail-value" style={{ color: "#ef4444" }}>
                  Failed / Incomplete
                </span>
              </div>
              <div className="cps-detail-row">
                <span className="cps-detail-label">Reason</span>
                <span className="cps-detail-value">{errorMsg}</span>
              </div>
              {orderId && (
                <div className="cps-detail-row">
                  <span className="cps-detail-label">Order Ref</span>
                  <span className="cps-detail-value">{orderId}</span>
                </div>
              )}
            </div>

            {/* Refund Assurance Banner */}
            <div className="cps-info-banner">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <div className="cps-info-banner-text">
                <strong>Zero Worry Guarantee</strong>
                If any money was debited from your bank or card, it will be automatically refunded by Razorpay within 3 to 5 business days.
              </div>
            </div>

            {/* Actions */}
            <div className="cps-actions">
              <button
                type="button"
                className="cps-btn-primary"
                onClick={this.handleBackToClasses}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Try Again / Back to Classes
              </button>

              <button
                type="button"
                className="cps-btn-secondary"
                onClick={() => this.props.history.push("/contact")}
              >
                Need Help? Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClassPaymentFailed);
